import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 18.261px;
  height: 18.107px;
  margin-right: 0.5rem;
`;

const TreeNonRunningVMIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <g data-name="Group 1100">
        <g data-name="Group 1098" fill="#bdcad2">
          <path
            data-name="Path 114"
            d="M1.326 14.932v1.751a1.411 1.411 0 0 0 .261.816L3 16.086v-2.828z"
          />
          <path
            data-name="Path 115"
            d="M10.967 7.043H9.215L7.541 8.717h2.828l1.414-1.413a1.414 1.414 0 0 0-.816-.261z"
          />
          <path data-name="Path 116" d="M12.151 4.109l-1.674 1.674h2.828l1.674-1.674z" />
          <path data-name="Path 117" d="M10.735 4.109H8.956v1.674h.105z" />
          <path data-name="Path 118" d="M8.869 9.978H7.195v1.913l1.674-1.674z" />
          <path
            data-name="Path 119"
            d="M16.836 4.109h-.444l-2.741 2.74v2.454h1.674v-3.52h1.261v7.72h-4.2V8.471a1.449 1.449 0 0 0-.039-.318l-1.635 1.635v3.715H8.864v-1.868L7.19 13.309v.444a1.425 1.425 0 0 0 1.424 1.423h2.1v1.261h-6.65l-1.635 1.635a1.39 1.39 0 0 0 .318.039h8.217a1.426 1.426 0 0 0 1.424-1.424v-1.511h4.445a1.425 1.425 0 0 0 1.424-1.423v-8.22a1.426 1.426 0 0 0-1.421-1.424z"
          />
          <path
            data-name="Path 120"
            d="M3 11.844V8.717h3.127l1.674-1.674h-5.05a1.426 1.426 0 0 0-1.424 1.424v5.051z"
          />
        </g>
        <g data-name="Group 1099">
          <path
            data-name="Path 121"
            d="M5.935 1.674h7.235L14.634.21a1.412 1.412 0 0 0-.733-.21H5.685a1.425 1.425 0 0 0-1.424 1.424v4.271h1.674z"
            fill="#bdcad2"
          />
        </g>
      </g>
      <path
        data-name="Rectangle 134"
        fill="#809dc4"
        d="M0 16.258L15.983.275l1.414 1.414L1.414 17.672z"
      />
    </Svg>
  );
};

export default TreeNonRunningVMIcon;
